// @flow
import React, { Component } from 'react';
import {
  EmptyTableTd,
  EmptyTableP,
  EmptyTableDiv,
  EmptyTableH5,
  EmptyTableImg
} from './EmptyTableStyles';
import ErrorMessage from './ErrorMessage';
import merchants from '../assets/images/merchants.png';
import moneyHand from '../assets/images/money-hand.png';
import partners from '../assets/images/partners.png';
import receipt from '../assets/images/receipt.png';
import thumbsUp from '../assets/images/thumbs-up.png';
import withdraw from '../assets/images/withdraw-atm.png';

const images = {
  merchants: { image: merchants, height: '84' },
  moneyHand: { image: moneyHand, height: '64' },
  partners: { image: partners, height: '84' },
  receipt: { image: receipt, height: '65' },
  withdraw: { image: withdraw, height: '63' },
  thumbsUp: { image: thumbsUp, height: '84' }
};
type ErrorProps = {
  error: true,
  model: string,
  columns: number
};
type TextProps = {
  columns: number,
  text?: string,
  error?: false,
  model?: string,
  title?: string,
  img?: string
};
type Props = ErrorProps | TextProps;

export default class EmptyTable extends Component<Props> {
  render() {
    return (
      <tr>
        <EmptyTableTd colSpan={this.props.columns}>
          {this.props.error ? (
            <ErrorMessage model={this.props.model} />
          ) : (
            <EmptyTableDiv>
              {this.props.img && (
                <EmptyTableImg
                  src={images[this.props.img].image}
                  height={images[this.props.img].height}
                />
              )}
              {this.props.title && (
                <EmptyTableH5>{this.props.title}</EmptyTableH5>
              )}
              <EmptyTableP styled={{ italic: !this.props.title }}>
                {this.props.text}
              </EmptyTableP>
            </EmptyTableDiv>
          )}
        </EmptyTableTd>
      </tr>
    );
  }
}
